export interface PresetImage {
  id: string;
  name: string;
  url: string;
  description: string;
}

export const presetImages: PresetImage[] = [
  {
    id: 'happy-birthday',
    name: 'Happy Birthday',
    url: 'https://blossom.ditto.pub/ddb81416cf0c8b73ce5bac693e5d7776cb8125928f9a07c7ddef85b951b693e4.jpeg',
    description: 'Birthday peanut character with party hat',
  },
  {
    id: 'you-got-ecash',
    name: 'You Got eCash',
    url: 'https://blossom.ditto.pub/c67449de2a36f227345855228f3cd228d7e65dde9f11df4b9463fab0ce7f1896.jpeg',
    description: 'Fun peanut character with sunglasses and a crown',
  },
];

/** Fixed back cover image (Cashu Cards branding + redeem URL) — always used */
export const BACK_COVER_URL = 'https://blossom.ditto.pub/d5627a733b3e788a5ccfc1014a233ea53f7c181e8df635180784e1ef2432d424.png';

/** The Cashu Cards logo used on the inside QR page */
export const REDEEM_IMAGE_URL = 'https://blossom.ditto.pub/71bfa8d0063268f968b9b818ba1624bacd484c518bfe008658d995a5bfb84921.png';
